import { inject, Injectable } from '@angular/core';
import { IItemsListFilter, ISelectedFilterItem } from './fi-items-list-filter/fi-items-list-filter';
import { ISideListOptionsItem } from '../fi-items-list';
import { FiFilterType } from './fi-filter-type-enum';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Injectable()
export class FiItemsListFilterHelperService {
    readonly filterTypeToPropertyNameRecord: Readonly<Partial<Record<FiFilterType, string>>> = {
        [FiFilterType.Checklist]: 'ChecklistIds',
        [FiFilterType.Schedule]: 'ScheduleIds',
        [FiFilterType.CheckpointGroup]: 'CheckpointGroupIds',
        [FiFilterType.Checkpoint]: 'CheckpointIds',
        [FiFilterType.BusinessUnit]: 'BusinessUnitIds',
        [FiFilterType.Area]: 'AreaIds',
        [FiFilterType.BusinessArea]: 'BusinessAreaIds',
        [FiFilterType.User]: 'UserIds',
        [FiFilterType.CheckpointStatus]: 'CheckpointStatusTypes',
        [FiFilterType.Role]: 'RoleIds',
        [FiFilterType.TaskName]: 'TaskNames',
        [FiFilterType.TaskStatus]: 'TaskStatuses',
        [FiFilterType.TaskPriority]: 'TaskPriorities',
        [FiFilterType.TaskCategory]: 'TaskCategories',
        [FiFilterType.Onboarding]: 'OnboardingIds',
        [FiFilterType.OnboardingCategory]: 'OnboardingCategories',
    };

    private fiFormatDateService = inject(FiFormatDateService);

    getCustomDateFilterLabel(start: Date | null, end: Date | null): string {
        return `${this.fiFormatDateService.formatDate(start, 'date')} - ${this.fiFormatDateService.formatDate(
            end,
            'date',
        )}`;
    }

    isFilterItemSelected(item: ISelectedFilterItem, filterItem: ISelectedFilterItem): boolean {
        return item.value === filterItem.value && item.filterType === filterItem.filterType;
    }

    convertSideListOptionsItemToFilterItem(item: ISideListOptionsItem, filterType: FiFilterType): ISelectedFilterItem {
        if (item) {
            return {
                name: item.text,
                value: item.value as number,
                filterType,
            };
        }
    }

    getFilterDataBySelectedItems(
        savedFilterData: IItemsListFilter,
        oldSavedFilterItems: ISelectedFilterItem[],
        newSavedFilterItems: ISelectedFilterItem[],
    ): IItemsListFilter {
        oldSavedFilterItems.forEach((savedFilterSelectedItem: ISelectedFilterItem) => {
            if (newSavedFilterItems.indexOf(savedFilterSelectedItem) === -1) {
                this.removeSelectedItemFromFilter(savedFilterSelectedItem, savedFilterData);
            }
        });
        return savedFilterData;
    }

    private removeSelectedItemFromFilter(item: ISelectedFilterItem, savedFilterData: IItemsListFilter) {
        if (item.filterType === FiFilterType.CustomDate) {
            savedFilterData.Settings.ChangedOnRange = undefined;
        } else if (item.filterType === FiFilterType.LastEdit) {
            savedFilterData.Settings.ChangedOnFilterType = undefined;
        } else {
            const filterSettingsByFilterType: number[] = this.getFilterSettingsByFilterType(
                item.filterType,
                savedFilterData,
            );
            filterSettingsByFilterType.splice(filterSettingsByFilterType.indexOf(+item.value), 1);
        }
    }

    private getFilterSettingsByFilterType(filterType: FiFilterType, savedFilterData: IItemsListFilter): number[] {
        switch (filterType) {
            case FiFilterType.Category:
                return savedFilterData.Settings.CategoryFilterTypes;
            case FiFilterType.Tag:
                return savedFilterData.Settings.TagIds;
            case FiFilterType.User:
                return savedFilterData.Settings.UserIds;
            case FiFilterType.BusinessUnit:
                return savedFilterData.Settings.BusinessUnitIds;
            case FiFilterType.Area:
                return savedFilterData.Settings.AreaIds;
            case FiFilterType.Cluster:
                return savedFilterData.Settings.ClusterIds;
            case FiFilterType.BusinessArea:
                return savedFilterData.Settings.BusinessAreaIds;
        }
    }
}
